import { render } from "./ybpj.vue?vue&type=template&id=e229969c&scoped=true&ts=true"
import script from "./ybpj.vue?vue&type=script&lang=ts"
export * from "./ybpj.vue?vue&type=script&lang=ts"

import "./ybpj.vue?vue&type=style&index=0&id=e229969c&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e229969c"]])

export default __exports__